import * as React from 'react'
import { Component } from 'react'
import styled from 'styled-components'
import { media } from '../../../utils'

const imgSlider01 = require('src/assets/wizard/contact/silke.png')
const imgSlider02 = require('src/assets/wizard/contact/sonja.png')
const imgSlider03 = require('src/assets/wizard/contact/karl.png')

export default class OpinionSlider extends Component {
  render() {
    const settings = {
      dots: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 7000
    }
    return (
      <React.Fragment>
      <Title>Bereits 2.100+ betreute Familien</Title>
        <CustomSlider {...settings}>
          <div className='content'>
          <img src={imgSlider02} />

          <div className='info'>
              <p>
                „Äußerst kompetente, zuverlässige und unkomplizierte Abwicklung.
                Zudem sehr bemüht, einfühlsam und zuvorkommend. Herzlichen Dank
                für Ihre Unterstützung, den Beistand und die wahrlich
                professionelle Abwicklung!“
              </p>
            </div>
            <div className='user'>
              <h4>Sonja P.</h4>
              <p>Google</p>
            </div>

          </div>

          <div className='content'>
          <img src={imgSlider01} />

          <div className='info'>
              <p>
                „Sehr freundliche und kompetente Beratung. Es ist alles zu
                unserer vollsten Zufriedenheit organisiert worden bzw. sind wir
                an notwendige Schritte erinnert worden. Gerade in der Zeit der
                größten Trauer war es für uns eine sehr große Erleichterung sich
                nicht mit der Organisation der Bestattung beschäftigen zu
                müssen. Ich kann Benu mit bestem Gewissen weiterempfehlen. “
              </p>
            </div>
            <div className='user'>
              <h4>Silke G.</h4>
              <p>Facebook</p>
            </div>

          </div>

          <div className='content'>
          <img src={imgSlider03} />

          <div className='info'>
              <p>
                „Höchst professionell, schnell. zuverlässig, einfühlsam,
                korrekt. unglaublich. Ein Service wie wir das schon lange nicht
                mehr erlebt haben. Der Clou ist, laut unseren Vergleichen auch
                noch günstiger als der Mitbewerb. Das einzige Institut mit einem
                online-Angebot!“{' '}
              </p>
            </div>
            <div className='user'>
              <h4>Karl B.</h4>
              <p>Google</p>
            </div>
          </div>
        </CustomSlider>
        </React.Fragment>
    )
  }
}


const Title = styled.h2`
    font-family: "Montserrat",Sans-serif;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 1px;
    margin-bottom: 20px;
    text-align: center;
`;
const CustomSlider = styled.div`
  width: 100% !important;
  margin: 0 auto;
  margin-bottom: 40px;
  display: flex ;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${media.tablet`
    flex-direction: column;
    justify-content: center;
  `}
  .content {

    width: 30%;
    margin-bottom: 20px;
    ${media.tablet`
      width: 100%;
    `}
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,.15);
    padding: 15px;

    img {
        margin: 10px calc(50% - 40px) 20px;
        width: 80px;
        height: 80px;

      }

    .user{


      h4 {
        width: 100%;
        font-size: 14px;
        /* text-align: center; */
        font-style: normal;
        font-weight: 700;
        margin: 0;
      }
      p {
        width: 100%;
        font-size: 12px;
        line-height: 1.4;
        font-style: italic;
        margin-bottom: 2px;
        /* text-align: center; */
        /* margin-bottom: 14px; */
      }
    }
    .info{
      p{font-size: 14px;}
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/molecules/wizard/OpinionSlider.tsx